export const defaultTouchSpinData = [
    "touchspin-primary",
    "touchspin-secondary",
    "touchspin-success",
    "touchspin-danger",
    "touchspin-warning",
    "touchspin-info",
    "touchspin-dark",
  ];

  export const outLinesTouchSpinData = [
    "spin-border-primary",
    "spin-border-secondary",
    "spin-border-success",
    "spin-border-danger",
    "spin-border-warning",
    "spin-border-info",
    "spin-border-dark",
  ];